<template>
  <!-- 入群关系绑定表 -->
  <div>
    <SpFinder
      id="1"
      ref="finder"
      :show-tool-bar="false"
      :no-selection="true"
      class="channelCode"
      :url="{
        data: requestUrl + '/salesperson/chat-user-bind/list'
      }"
      :setting="{
        search: [
          {
            type: 'input',
            key: 'chat_name',
            name: '群名称',
            placeholder: '输入群名称'
          },
          {
            type: 'input',
            key: 'chat_id',
            name: '群ID',
            placeholder: '输入群ID多个用逗号分隔'
          }
        ]
      }"
      title="数据"
      :columns="columns"
      :actions="actions"
    />

    <!-- 批量导入 -->
    <SpBulkImport
      v-model="importVisible"
      file-type="characteristic_group"
      title="批量导入绑定社群"
      @saveImportAction="saveImportAction"
    >
      <div>
        批量导入说明： <br>
        1、下载社群绑定模版文件<br>
        2、根据填写要求填写门店绑定的社群，上传并导入文件，文件格式必须为xlsx<br>
        3、单次上传xlsx最大条目数（行数）为5000，超出请安文件分批上传<br>
        4、上传后系统将校验文件内容格式，如有误，需根据提示修改后重新上传
      </div>
    </SpBulkImport>
  </div>
</template>

<script>
export default {
  data () {
    const columns = [
      {
        name: '群ID', // 表头
        key: 'chat_id' // 匹配data key
      },
      {
        name: '群名称', // 表头
        key: 'chat_name' // 匹配data key
      },
      {
        name: '入群绑定员工号', // 表头
        key: 'bind_userid' // 匹配data key
      }
    ]

    const actions = [
      {
        name: '批量导入',
        key: 'create', // 用于指定key,必填
        slot: 'header',
        type: 'button',
        buttonType: 'primary',
        action: {
          type: 'dialog',
          handler: () => {
            this.importVisible = true
          }
        }
      },
      {
        name: '删除',
        key: 'delete',
        type: 'button',
        action: {
          type: 'api',
          // path: (row) => `/salesperson/chat-user-bind/update?ids=${row.id}&action_type=1&chat_id=${row.chat_id}`, // api url
          path: async (data) =>
            await this.$http.post('/salesperson/chat-user-bind/update', {
              ids: data[0].id,
              chat_id: data[0].chat_id,
              action_type: 1
            }),
          onSuccess: () => {
            this.$refs.finder.refresh()
          },
          confirm: {
            message: '请确认是否删除？',
            title: '提示'
          }
        }
      }
    ]

    return {
      importVisible: false, // 批量导入

      columns,
      actions,
      requestUrl: process.env.VUE_APP_BASE_API
    }
  },
  mounted () {},
  methods: {
    // 确定导入
    saveImportAction () {
      this.$refs.finder.refresh()
    }
  }
}
</script>

<style lang="scss" scoped></style>
